module.exports = __webpack_public_path__ + "static/media/loiro.1ff5d5b4.png";